import css from '@emotion/css/macro'
import styled from '@emotion/styled/macro'
import { FieldConfig, Form } from 'formik'
import { Dictionary } from 'lodash'
import { ifProp } from 'mixins'
import { IStackItemProps, IStackProps, Stack } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTheme } from 'theme'
import { AuthorizedField as Field } from './AuthorizedField'

export { Stack } from 'office-ui-fabric-react'

const StyledStackItem = styled(Stack.Item)`
  ${ifProp(
    (props) =>
      (props.grow === true || props.grow === 1) &&
      (props.disableShrink || props.shrink === 0),
    css`
      flex-basis: 0%;
    `
  )}
`

export const FormStack: React.FunctionComponent<IStackProps> = ({
  children,
  ...props
}) => {
  const theme = useTheme()
  return (
    <Form>
      <Stack tokens={{ childrenGap: theme.space![2] }} {...props}>
        {children}
      </Stack>
    </Form>
  )
}

export const FieldStack: React.FunctionComponent<IStackProps> = ({
  children,
  ...props
}) => {
  const theme = useTheme()

  return (
    <StyledStackItem grow={1}>
      <Stack
        tokens={{ childrenGap: `${theme.space![1]} ${theme.space![2]}` }}
        {...props}
      >
        {children}
      </Stack>
    </StyledStackItem>
  )
}
FieldStack.displayName = 'FieldStack'

export const FieldStackItem: React.FunctionComponent<
  FieldConfig &
    Dictionary<any> & { stack?: IStackItemProps } & {
      grow?: boolean | number
    } & {
      disableShrink?: boolean
    }
> = ({ stack, grow = true, disableShrink = true, ...props }) => (
  <StyledStackItem grow={grow} disableShrink={disableShrink} {...stack}>
    <Field {...props} />
  </StyledStackItem>
)
FieldStackItem.displayName = 'FieldStackItem'
